/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Submit_ApplicationInputs */

const en_submit_application = /** @type {(inputs: Submit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit Application`)
};

const de_submit_application = /** @type {(inputs: Submit_ApplicationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung abschicken`)
};

/**
* | output |
* | --- |
* | "Submit Application" |
*
* @param {Submit_ApplicationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const submit_application = /** @type {((inputs?: Submit_ApplicationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_ApplicationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_submit_application(inputs)
	return en_submit_application(inputs)
});